(function () {
  var api = window.NCProductIntroPurchase || {};

  function updateGallery(root, index) {
    var images = Array.prototype.slice.call(root.querySelectorAll(".nc-product-intro-purchase__gallery-image"));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-nc-product-intro-thumb]"));
    var prevButtons = root.querySelectorAll("[data-nc-product-intro-prev]");
    var nextButtons = root.querySelectorAll("[data-nc-product-intro-next]");
    var maxIndex = Math.max(0, images.length - 1);
    var nextIndex = Math.min(Math.max(index, 0), maxIndex);

    root.dataset.ncProductIntroActiveIndex = String(nextIndex);

    images.forEach(function (image, imageIndex) {
      image.classList.toggle("is-active", imageIndex === nextIndex);
    });

    thumbs.forEach(function (thumb, thumbIndex) {
      thumb.classList.toggle("is-active", thumbIndex === nextIndex);
      thumb.setAttribute("aria-pressed", thumbIndex === nextIndex ? "true" : "false");
    });

    prevButtons.forEach(function (button) {
      button.disabled = nextIndex <= 0;
    });

    nextButtons.forEach(function (button) {
      button.disabled = nextIndex >= maxIndex;
    });
  }

  function closeShare(root) {
    var share = root.querySelector("[data-nc-product-intro-share]");
    var trigger = root.querySelector("[data-nc-product-intro-share-trigger]");
    var popover = root.querySelector("[data-nc-product-intro-share-popover]");

    if (share) {
      share.classList.remove("is-open");
    }

    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    }

    if (popover) {
      popover.hidden = true;
    }
  }

  function setShareOpen(root, isOpen) {
    var share = root.querySelector("[data-nc-product-intro-share]");
    var trigger = root.querySelector("[data-nc-product-intro-share-trigger]");
    var popover = root.querySelector("[data-nc-product-intro-share-popover]");

    if (share) {
      share.classList.toggle("is-open", isOpen);
    }

    if (trigger) {
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }

    if (popover) {
      popover.hidden = !isOpen;
    }
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand("copy");
        document.body.removeChild(textarea);
        resolve();
      } catch (error) {
        document.body.removeChild(textarea);
        reject(error);
      }
    });
  }


  function initRoot(root) {
    if (!root || root.dataset.ncProductIntroInitialized === "true") return;

    var images = root.querySelectorAll("[data-nc-product-intro-image]");
    var thumbs = root.querySelectorAll("[data-nc-product-intro-thumb]");
    var prevButtons = root.querySelectorAll("[data-nc-product-intro-prev]");
    var nextButtons = root.querySelectorAll("[data-nc-product-intro-next]");
    var accordionTriggers = root.querySelectorAll("[data-nc-product-intro-accordion-trigger]");
    var shareTrigger = root.querySelector("[data-nc-product-intro-share-trigger]");
    var copyButton = root.querySelector("[data-nc-product-intro-copy]");
    var copyLabel = root.querySelector("[data-nc-product-intro-copy-label]");
    var emailLink = root.querySelector("[data-nc-product-intro-email]");

    root.dataset.ncProductIntroInitialized = "true";

    if (emailLink && window.location.href) {
      var title = document.title || "";
      emailLink.href = "mailto:?subject=" + encodeURIComponent(title) + "&body=" + encodeURIComponent(window.location.href);
    }

    updateGallery(root, 0);

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        updateGallery(root, Number(thumb.getAttribute("data-nc-product-intro-thumb")) || 0);
      });
    });

    prevButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var current = Number(root.dataset.ncProductIntroActiveIndex || "0");
        updateGallery(root, current - 1);
      });
    });

    nextButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var current = Number(root.dataset.ncProductIntroActiveIndex || "0");
        updateGallery(root, current + 1);
      });
    });

    accordionTriggers.forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var item = trigger.closest(".nc-product-intro-purchase__detail-item");
        var panel = item ? item.querySelector("[data-nc-product-intro-accordion-panel]") : null;
        var isOpen = item ? item.classList.contains("is-open") : false;

        if (!item || !panel) return;

        if (!isOpen) {
          accordionTriggers.forEach(function (otherTrigger) {
            if (otherTrigger === trigger) return;
            var otherItem = otherTrigger.closest(".nc-product-intro-purchase__detail-item");
            var otherPanel = otherItem ? otherItem.querySelector("[data-nc-product-intro-accordion-panel]") : null;
            if (otherItem) otherItem.classList.remove("is-open");
            otherTrigger.setAttribute("aria-expanded", "false");
            if (otherPanel) otherPanel.hidden = true;
          });
        }

        item.classList.toggle("is-open", !isOpen);
        trigger.setAttribute("aria-expanded", !isOpen ? "true" : "false");
        panel.hidden = isOpen;
      });
    });

    if (shareTrigger) {
      shareTrigger.addEventListener("click", function () {
        if (navigator.share) {
          closeShare(root);
          navigator.share({
            title: document.title || "",
            url: window.location.href
          }).catch(function () {});
          return;
        }

        var share = root.querySelector("[data-nc-product-intro-share]");
        setShareOpen(root, !(share && share.classList.contains("is-open")));
      });
    }

    if (copyButton) {
      copyButton.addEventListener("click", function () {
        copyToClipboard(window.location.href)
          .then(function () {
            if (copyLabel) {
              copyLabel.textContent = "Copied";
              window.setTimeout(function () {
                copyLabel.textContent = "Copy link";
              }, 1600);
            }
          })
          .catch(function () {
            if (copyLabel) {
              copyLabel.textContent = "Copy failed";
              window.setTimeout(function () {
                copyLabel.textContent = "Copy link";
              }, 1600);
            }
          });
      });
    }

    root.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeShare(root);
      }
    });

    if (!images.length) {
      updateGallery(root, 0);
    }
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-product-intro]")
      : [];

    if (scope.matches && scope.matches("[data-nc-product-intro]")) {
      initRoot(scope);
    }

    roots.forEach(initRoot);
  }

  function closeAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-product-intro]")
      : [];

    if (scope.matches && scope.matches("[data-nc-product-intro]")) {
      closeShare(scope);
    }

    roots.forEach(closeShare);
  }

  function closeSharesOutside(target) {
    var roots = document.querySelectorAll("[data-nc-product-intro]");

    roots.forEach(function (root) {
      if (!root.contains(target)) {
        closeShare(root);
      }
    });
  }

  api.initAll = initAll;
  api.closeAll = closeAll;
  api.closeSharesOutside = closeSharesOutside;
  window.NCProductIntroPurchase = api;

  if (!window.__ncProductIntroPurchaseEventsBound) {
    window.__ncProductIntroPurchaseEventsBound = true;

    document.addEventListener("DOMContentLoaded", function () {
      window.NCProductIntroPurchase.initAll(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
      window.NCProductIntroPurchase.initAll(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      window.NCProductIntroPurchase.closeAll(event.target);
    });

    document.addEventListener("click", function (event) {
      window.NCProductIntroPurchase.closeSharesOutside(event.target);
    });
  }

  if (document.readyState !== "loading") {
    window.NCProductIntroPurchase.initAll(document);
  }
})();
